import { render, staticRenderFns } from "./v-date-picker.vue?vue&type=template&id=28016647&scoped=true&"
import script from "./v-date-picker.vue?vue&type=script&lang=js&"
export * from "./v-date-picker.vue?vue&type=script&lang=js&"
import style0 from "./v-date-picker.vue?vue&type=style&index=0&id=28016647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28016647",
  null
  
)

export default component.exports